import { Component, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { AuthService } from '../../api-authorization/authorize.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-user-register',
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.css']
})
export class UserRegisterComponent implements OnInit {
  changePasswordForm: FormGroup;
  isLoading = false;
  error: string | null = null;
  hideOldPassword = signal(true);
  hideNewPassword = signal(true);
  hideConfirmPassword = signal(true);

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.changePasswordForm = this.fb.nonNullable.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    this.changePasswordForm.valueChanges.subscribe(() => {
      this.error = null;  // Reset error message on any form change
    });
  }

  passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
    const newPassword = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    const confirmControl = group.get('confirmPassword');

    if (confirmControl) {
      const currentErrors = confirmControl.errors || null;
      if (compare(newPassword, confirmPassword)) {
        confirmControl.setErrors({ ...currentErrors, not_matching: true });
      } else {
        confirmControl.setErrors(currentErrors);
      }
    }
    return null;
  }

  toggleVisibility(signalToToggle: any) {
    signalToToggle.set(!signalToToggle());
  }

  /** Liest die konkrete Server-Meldung (z.B. "Das Passwort muss mindestens 8 Zeichen lang sein."). */
  private readError(error: any): string {
    const msg = error?.error;
    if (typeof msg === 'string' && msg.trim()) {
      return msg;
    }
    if (msg?.message) {
      return msg.message;
    }
    return 'Fehler beim Ändern des Passworts. Bitte überprüfen Sie Ihre Eingaben.';
  }

  onSubmit(): void {
    this.isLoading = true;
    this.error = null;

    if (this.changePasswordForm.valid) {
      const { oldPassword, newPassword } = this.changePasswordForm.value;
      this.authService.changePassword(oldPassword, newPassword)
        .pipe(
          catchError(error => {
            this.error = this.readError(error);
            this.isLoading = false;
            return of(null);
          })
        )
        .subscribe({
          next: result => {
            if (result === null) { return; } // Fehler wurde bereits behandelt
            this.router.navigateByUrl('/users'); // Redirect to another page after successful password change
            this.isLoading = false;
          },
          error: error => {
            this.error = this.readError(error);
            this.isLoading = false;
          }
        });
    } else {
      this.isLoading = false;
    }
  }
}

function compare(password: string, confirmPassword: string) {
  return password !== confirmPassword && confirmPassword !== '';
}
